// @flow
import type { Episode } from 'Common/franchise/types';
import type { DownloadingContent } from 'Native/downloads/types';

export const BINGE_WATCHING_PERIOD = 45;

export const getNextEpisode = (
  episodes: Array<Episode>,
  videoId: string,
  downloads: Array<DownloadingContent> = [],
  isInternetReachable: boolean = true,
) => {
  if (!episodes) return undefined;

  const currentEpisode = episodes.find(episode => episode.video_id === videoId);

  if (!currentEpisode) return undefined;

  const nextEpisode = episodes.find(
    episode =>
      episode.season_number === currentEpisode.season_number &&
      episode.episode_number === currentEpisode.episode_number + 1,
  );

  if (isInternetReachable || nextEpisode === undefined) return nextEpisode;

  return downloads.find(
    item =>
      item.content_identification.content_id === nextEpisode.content_identification.content_id,
  );
};
